package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.PulseCheckDTO
import gr.tech.meetinggenie.models.meeting.WeeklyFeel
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun PulseCheckInput(
    pulseCheck: PulseCheckDTO,
    onUpdate: (PulseCheckDTO) -> Unit,
) {
    Column(modifier = Modifier.fillMaxWidth().gap(16.px)) {

        // This week felt — radio row
        Column(modifier = Modifier.fillMaxWidth().gap(8.px)) {
            Label(attrs = GeneralInputLabelStyle.toModifier().toAttrs()) {
                Text("This week felt:")
            }
            Row(horizontalArrangement = Arrangement.spacedBy(20.px)) {
                WeeklyFeel.entries.forEach { option ->
                    Label(attrs = RadioOptionLabelStyle.toModifier().toAttrs()) {
                        Input(
                            type = InputType.Radio,
                            attrs = RadioInputStyle.toModifier().toAttrs {
                                id("pulse-feel-${option.name}")
                                attr("name", "pulse-feel")
                                checked(pulseCheck.weeklyFeel == option)
                                onClick { onUpdate(pulseCheck.copy(weeklyFeel = option)) }
                            }
                        )
                        Text(option.label)
                    }
                }
            }
        }

        // Anything blocking you — textarea; optional
        Column(modifier = Modifier.fillMaxWidth().gap(4.px)) {
            Label(attrs = GeneralInputLabelStyle.toModifier().toAttrs()) {
                Text("Anything blocking you that we might be missing?")
                Span(
                    attrs = Modifier
                        .color(Colors.Gray)
                        .fontSize(0.8.cssRem)
                        .margin(left = 6.px)
                        .toAttrs()
                ) { Text("(optional)") }
            }
            TextArea(
                value = pulseCheck.blockersNote,
                attrs = GeneralTextAreaStyle.toModifier().toAttrs {
                    placeholder("Share anything on your mind...")
                    ref { el ->
                        el.style.height = "auto"
                        el.style.height = "${el.scrollHeight}px"
                        onDispose {}
                    }
                    onInput { event ->
                        event.target.style.height = "auto"
                        event.target.style.height = "${event.target.scrollHeight}px"
                        onUpdate(pulseCheck.copy(blockersNote = event.value))
                    }
                }
            )
        }
    }
}
